// extracted by mini-css-extract-plugin
export default {"additional-acc-expiration-text":"IX8aB","block-link":"qcRMU","error-block":"Can7Z"};